import React from 'react';
import { Col, Row } from 'components';
import { PERMISSIONS } from 'constants/permissions';
import { HasAccess } from 'components/common/accessControl';
import { LatestStatistics } from './latestStatistics';
import { ShippingRates } from './shippingRates';

export const SupplierShipping = React.memo(() => {
  return (
    <Row className={'gap-32'}>
      <Col flex={'1'}>
        <HasAccess role={PERMISSIONS.suppliers.latest_statistics.read}>
          <LatestStatistics />
        </HasAccess>
      </Col>
      <Col flex={'1'}>
        <HasAccess role={PERMISSIONS.suppliers.shipping_rate.read}>
          <ShippingRates />
        </HasAccess>
      </Col>
    </Row>
  );
});
